
// MVアニメーション
$(function(){
  $('.js-mvText1').delay(300).queue(function() {
    $(this).addClass('show').dequeue();
  });
  $('.js-mvText2').delay(1000).queue(function() {
    $(this).addClass('show').dequeue();
  });
});

// ご購入はこちらバナー
$(function(){
	$(window).scroll(function(){
		if ($(this).scrollTop() > 200) {
			$('.js-fixSection').addClass('show');
		}
		else {
			$('.js-fixSection').removeClass('show');
		}
	});
});

// 画面最下部は背景動画非表示
$(window).on('scroll', function() {
	const scrollTop = $(window).scrollTop();
	const windowHeight = $(window).height();
	const documentHeight = $(document).height();
	if (scrollTop + windowHeight >= documentHeight - 500) {
		$('.movieSection').addClass('blank');
	} else {
		$('.movieSection').removeClass('blank');
	}
});
